var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/load_more.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'soapbox/components/ui';
const LoadMore = ({
  onClick,
  disabled,
  visible = true
}) => {
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    block: true,
    disabled: disabled || !visible,
    onClick: onClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "status.load_more",
    defaultMessage: "Load more",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }));
};
export default LoadMore;